const angular = require('angular')
/*
 *   Section
 *   usage: $section.open( object );
 *   param: object
 *          object.template String 显示的template，与templateUrl二者只能选其一
 *          object.templateUrl String，显示的template的URL
 *          object.enterAttrs Object，指定该section进入时需要设置的attrs <section attr1="attr1" attr2="attr2"></section>
 *          object.leaveAttrs Object, 指定该section离开时需要设置的attrs，同上
 *          object.index int, 指定该section dom元素的z-index数值若不指定，默认为1000
 *          object.resolves object 此处为需要在原调用页面中传入的控制参数，回调函数等内容
 *              初始化时会将此对象的每个属性复制到scope中供后续调用
 *              当然也可以在下面指定的scope或controller中定义各种控制方法和数据，那就不需要此参数了
 *          object.scope 指定section使用何种scope，若不指定，默认从rootScope中重新创建
 *          object.controller 指定section使用何种controller
 *   请保证同时间内只调用一个section.open的实例(暂不支持从section中再弹出一个section或者同时弹出两个section)
 */
angular.module('ui.hxphone.section', [])

  .directive('section', ['$document', '$transition', '$timeout', function ($document, $transition, $timeout) {
    return {
      restrict: 'A',
      replace: true,
      transclude: true,
      templateUrl: 'views/components/section.html',
      link: function (scope, element, attrs) {
        // 根据enterAttrs触发进入动画
        const enterAttrs = scope.enterAttrs
        for (const i in enterAttrs) {
          if (enterAttrs.hasOwnProperty(i)) {
            element.attr(i, enterAttrs[i])
          }
        }

        const events = 'animationend webkitAnimationEnd transitionend webkitTransitionEnd'
        element.one(events, function() {
          for (const i in enterAttrs) {
            if (enterAttrs.hasOwnProperty(i)) {
              element.removeAttr(i)
            }
          }
          // 新section在换进来时默认隐藏，在这里才显示。这样子做是为了解决换页时的视图抖动
          element.css({'opacity': 1})
        })
      }
    }
  }])

  .provider('$section', function() {
    return {
      $get: ['$injector', '$document', '$rootScope', '$q', '$http', '$templateCache',
        '$controller', '$compile', '$$uiHelpers',
        function ($injector, $document, $rootScope, $q, $http, $templateCache,
          $controller, $compile, $$uiHelpers) {
          const $section = {}
          let sectionScope, sectionDomEl

          function getTemplatePromise(options) {
            return options.template ? $q.when(options.template)
              : $http.get(options.templateUrl, {cache: $templateCache}).then(function (result) {
                return result.data
              })
          }

          function getResolvesParams(resolves) {
            const resolvesParams = []
            angular.forEach(resolves, function (value, key) {
              resolvesParams.push(value)
            })
            return resolvesParams
          }

          function removeSection() {
            // 触发离开动画
            const leaveAttrs = sectionScope.leaveAttrs
            for (const i in leaveAttrs) {
              if (leaveAttrs.hasOwnProperty(i)) {
                sectionDomEl.attr(i, leaveAttrs[i])
              }
            }

            // remove section DOM element
            $$uiHelpers.removeAfterAnimate(sectionDomEl, sectionScope, 300, angular.noop())
            sectionDomEl = null
            // remove scope
            sectionScope.$destroy()
            sectionScope = null
          }

          $section.open = function(options) {
            // prepare an instance of a modal to be injected into controllers and returned to a caller
            const instance = {
              close: function (result) {
                if (!sectionDomEl) {
                  throw new Error("Can't not close section before open it!")
                } else {
                  removeSection()
                }
              }
            }

            options = options || {}
            options.index = options.index || 1000
            options.resolves = options.resolves || {}

            // verify options
            if (!options.template && !options.templateUrl) {
              throw new Error('One of template or templateUrl options is required.')
            }

            const templateAndResolvePromise =
                                $q.all([getTemplatePromise(options)].concat(getResolvesParams(options.resolves)))

            templateAndResolvePromise.then(
              function resolveSuccess(tplAndVars) {
                sectionScope = (options.scope || $rootScope).$new()
                // 注入动画属性
                sectionScope.enterAttrs = options.enterAttrs
                sectionScope.leaveAttrs = options.leaveAttrs

                let resolveIter = 1
                const ctrlLocals = {}

                // controllers
                if (options.controller) {
                  ctrlLocals.$scope = sectionScope
                  ctrlLocals.$modalInstance = instance
                  angular.forEach(options.resolves, function (value, key) {
                    ctrlLocals.$scope[key] = tplAndVars[resolveIter++]
                  })
                  $controller(options.controller, ctrlLocals)
                } else {
                  angular.forEach(options.resolves, function (value, key) {
                    sectionScope[key] = tplAndVars[resolveIter++]
                  })
                }

                // build section
                const body = $document.find('body').eq(0)

                const angularDomEl = angular.element('<div section></div>')
                angularDomEl.html(tplAndVars[0])
                sectionDomEl = $compile(angularDomEl)(sectionScope)
                body.append(angularDomEl)
                // 将实例注入scope，以便向模板提供close方法
                sectionScope.instance = instance
                sectionScope.index = options.index
              }
            )
            return instance
          }

          return $section
        }]
    }
  })

/**
 * 联系人选择页面
 *
 * usage
 *  $sectionContact.open({
 *       index : 2000,                          // 设置z-index，可选
 *       deferredContactClick : deferred...     // 一个Defer对象，用于控制点击联系人后的回调
 *       deferredCancelClick : deferred...      // 一个Defer对象，用于控制点击取消后的回调
 *  })
 */
  .provider('$sectionContact', function() {
    return {
      $get: ['$section', function ($section) {
        const $sectionContact = {}
        $sectionContact.open = function(options) {
          options = options || {}
          const sectionOptions = {
            template: require('views/addressBook/selectContactListModal.html'),
            enterAttrs: {
              'data-transition': 'cover',
              'data-direction': 'in'
            },
            leaveAttrs: {
              'data-transition': 'coverBack',
              'data-direction': 'back-out'
            },
            index: options.index || 2000,
            controller: 'ContactCtrl',
            resolves: {
              // 点击某个联系人时触发的回调
              deferredContactClick: options.deferredContactClick,
              // 点击取消按钮后触发的回调
              deferredCancelClick: options.deferredCancelClick
            }
          }
          return $section.open(sectionOptions)
        }
        return $sectionContact
      }]
    }
  })



// WEBPACK FOOTER //
// ./src/js/infrastructure/section.js